import { action } from 'satcheljs/lib/legacy';
import FilePickerViewState, { FilePickerBreadcrumb } from '../store/schema/FilePickerViewState';
import { ScopeBreadcrumbId, SearchBreadcrumbId } from '../utils/filePickerConstants';

export default action('pushFilePickerBreadcrumb')(function pushFilePickerBreadcrumb(
    breadcrumb: FilePickerBreadcrumb,
    viewState: FilePickerViewState
) {
    // If we load more items, but already have the breadcrumb we do not want to load a second copy of the breadcrumb
    // For folders we check the associated folder, for scopes we know we should only have one scope breadcrumb at any time,
    // so we check if we have a scope breadcrumb or not (all scope breadcrumbs have the same id).
    const doesAlreadyContainBreadcrumb =
        viewState.breadcrumbs.filter(
            b =>
                (b.associatedItem !== null && b.associatedItem === breadcrumb.associatedItem) ||
                (b.id === ScopeBreadcrumbId && breadcrumb.id === ScopeBreadcrumbId) ||
                (b.id === SearchBreadcrumbId && breadcrumb.id === SearchBreadcrumbId)
        ).length !== 0;

    if (breadcrumb && !doesAlreadyContainBreadcrumb) {
        viewState.breadcrumbs.push(breadcrumb);
    }
});
